import { useState, useEffect } from 'react';
import { Link } from 'wouter';
import { Button } from '@/components/ui/button';

export const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background/75 backdrop-blur-xl border-b border-border/40' : 'bg-transparent'}`}>
            <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
                <Link href="/" className="flex items-center gap-2.5">
                    <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
                        <span className="text-primary-foreground font-bold text-base leading-none">H</span>
                    </div>
                    <span className="font-semibold text-base tracking-tight text-foreground">Handoff</span>
                </Link>

                <nav className="hidden md:flex items-center gap-7 text-sm text-muted-foreground">
                    <a href="#in-one-line" className="hover:text-foreground transition-colors">
                        What we do
                    </a>
                    <a href="#how-it-works" className="hover:text-foreground transition-colors">
                        How it works
                    </a>
                    <a href="#moments" className="hover:text-foreground transition-colors">
                        Departures
                    </a>
                    <a href="#savings" className="hover:text-foreground transition-colors">
                        ROI
                    </a>
                    <Link href="/pricing" className="hover:text-foreground transition-colors">
                        Pricing
                    </Link>
                </nav>

                <div className="flex items-center gap-2">
                    <Link href="/dashboard">
                        <Button variant="ghost" size="sm" className="text-sm">
                            Sign in
                        </Button>
                    </Link>
                    <Link href="/dashboard">
                        <Button size="sm" className="text-sm rounded-full px-4">
                            Book a call
                        </Button>
                    </Link>
                </div>
            </div>
        </header>
    );
};
